import { createContext, useContext } from "react";

// Types
import { GenerateType } from "../types";

interface GenerateContextType {
  type: GenerateType | null;
  onCloseMainModal: () => void;
}

const GenerateModalContext = createContext<GenerateContextType>({
  type: null,
  onCloseMainModal: () => {},
});

export const GenerateModalProvider = GenerateModalContext.Provider;

export const useGenerateModalContext = () => {
  const context = useContext(GenerateModalContext);

  if (!context) {
    throw new Error('useGenerate must be used within a GenerateProvider');
  }

  return context;
};
